import gql from 'graphql-tag'

import apolloClient from '@/vendor/apollo'
import { HR_DEPARTMENT_PARTS } from './fragments'

export function getDepartment (id, widthChild = true, withEmployees = true) {
  return apolloClient.query({
    query: gql`
      query GetDepartment($id: Int!, $withEmployees: Boolean!, $widthChild: Boolean!) {
        my_department (id: $id) {
          ...HrDepartmentParts
        }
      }
      ${HR_DEPARTMENT_PARTS}
    `,
    variables: {
      id,
      withEmployees,
      widthChild
    }
  }).then(res => res.data.myDepartment)
}

export function getMyDepartments (withEmployees = true, widthChild = true) {
  return apolloClient.query({
    query: gql`
      query GetMyDepartments ($withEmployees: Boolean!, $widthChild: Boolean!) {
        my_departments {
          ...HrDepartmentParts
        }
      }
      ${HR_DEPARTMENT_PARTS}
    `,
    variables: {
      withEmployees,
      widthChild
    }
  }).then(res => res.data.myDepartments)
}

export function getHrbpDepartments (id, widthChild = true, withEmployees = true) {
  return apolloClient.query({
    query: gql`
      query GetHrbpDepartments ($id: Int, $withEmployees: Boolean!, $widthChild: Boolean!) {
        departments (parent_id: $id) {
          ...HrDepartmentParts
        }
      }
      ${HR_DEPARTMENT_PARTS}
    `,
    variables: {
      id,
      withEmployees,
      widthChild
    }
  }).then(res => res.data.departments)
}

export function getHrbpDepartment (id, widthChild = true, withEmployees = true) {
  return apolloClient.query({
    query: gql`
      query GetHrbpDepartment ($id: Int!, $withEmployees: Boolean!, $widthChild: Boolean!) {
        department (id: $id) {
          ...HrDepartmentParts
        }
      }
      ${HR_DEPARTMENT_PARTS}
    `,
    variables: {
      id,
      withEmployees,
      widthChild
    }
  }).then(res => res.data.department)
}
